<template>
    <div class="node-info">
    <el-form label-position="right" size="mini" label-width="130px">
        <el-row>
            <el-col :span="12">
              <el-form-item label="任务节点名称">
                  <div><font color="green" class="el-tooltip item" aria-describedby="el-tooltip-2913" tabindex="0">{{element.taskName}}</font></div>
              </el-form-item>
            </el-col>
              <el-col :span="12">
                <el-form-item label="列表显示顺序">
                  <el-tooltip  content="在流程任务列表里显示的顺序，为0则表示不排序，数字从1开始按递增顺序排序" effect="light" placement="top">
                    <el-input-number v-model="nodeInfo.viewOrder" :min="0" :max="100" label="列表显示顺序"></el-input-number>
                  </el-tooltip> 
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
              <el-form-item label="计划开始时间">
                <el-tooltip  content="计划开始时间,不填的话系统默设置为上一个任务的实际完成时间顺延?天后,清空日期可设置自动顺延的?天数" effect="light" placement="top">
                  <el-date-picker
                      v-model="nodeInfo.planStartTime"
                      type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      :editable="true"
                      :clearable="true"
                      default-time="12:30:00"
                  />
                </el-tooltip>
                <template v-if="isShowAddSDays" >
                    <el-tooltip  content="设置自动顺延的?天数，默认顺延1天" effect="light" placement="top">
                      <el-input-number v-model="nodeInfo.addSDays" :min="0" :max="100" label="天数"></el-input-number>
                    </el-tooltip>
                    天
                  </template>
              </el-form-item>
            </el-col>
            <el-col :span="12">
                <!-- v-model="nodeInfo.actualStartTime" -->
               <!-- <el-form-item label="实际开始时间">
                  <el-tooltip  content="平台生成当前任务实例时的时间" effect="light" placement="right">
                      <el-date-picker
                          v-model="nodeInfo.created"
                          type="datetime"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          :readonly="true"
                          :editable="false"
                          :clearable="true"
                      />
                  </el-tooltip>
                </el-form-item> -->
                <el-col :span="12">
                  <el-form-item label="任务难度分数">
                      <el-tooltip  content="设置难度分后系统会自动统计相关分数，在运营中心可以看到任务相关指标" effect="light" placement="top">
                        <el-input-number v-model="nodeInfo.difficultScore" :min="0" :max="100" label="任务难度分"></el-input-number>
                      </el-tooltip>
                  </el-form-item>
                </el-col>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
               <el-form-item label="计划完成时间">
                  <el-tooltip  content="即:任务到期时间，到时间任务未完成则系统会发送逾期提醒消息,不填的话系统默设置为上一个任务计划完成时间顺延?天后,清空日期可设置自动顺延的?天数" effect="light" placement="top">
                       <!-- v-model="nodeInfo.dueDate" -->
                    <el-date-picker
                        v-model="nodeInfo.planEndTime"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :editable="true"
                        :clearable="true"
                        default-time="12:30:00"
                    />
                  </el-tooltip> 
                  <template v-if="isShowAddEDays" >
                    <el-tooltip  content="设置自动顺延的?天数，默认3天" effect="light" placement="top">
                      <el-input-number v-model="nodeInfo.addEDays" :min="0" :max="100" label="天数"></el-input-number>
                    </el-tooltip>
                    天
                  </template>
                    <!-- placeholder="系统默认当前时间一周后" -->
                    <!-- placeholder="默认上一个任务结束的一周后" -->
                    <!-- default-time="timeDefaultShow" -->
                </el-form-item>
            </el-col>
            <el-col :span="12">
               <!-- v-model="nodeInfo.endDate" -->
              <!-- <el-form-item label="实际完成时间">
                <el-tooltip  content="当前任务负责人点击完成任务的时间" effect="light" placement="right">
                    <el-date-picker
                        v-model="nodeInfo.actualEndTime"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :editable="false"
                        :clearable="true"
                        :readonly="true"
                    />
                </el-tooltip>
              </el-form-item> -->
               <!-- placeholder="系统默认当前时间一周后" -->
                    <!-- placeholder="默认上一个任务结束的一周后" -->
                    <!-- default-time="timeDefaultShow" -->
                  <el-col :span="12">
                    <el-form-item label="任务难度级别">
                          <!-- <el-radio-group v-model="nodeInfo.difficultLevel" size="mini">
                            <el-radio :label="0">简单</el-radio>
                            <el-radio :label="1">中等</el-radio>
                            <el-radio :label="2">困难</el-radio>
                          </el-radio-group> -->
                            <el-rate v-model="nodeInfo.difficultLevel" :colors="colors"></el-rate>
                      </el-form-item>
                  </el-col>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
              <el-form-item label="任务提醒时间">
                <el-tooltip  content="设置提醒时间后,到达设置时间时系统会发送到期提醒消息" effect="light" placement="top">
                    <el-date-picker
                        v-model="nodeInfo.expireDate"
                        type="datetime"
                        placeholder=""
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :editable="true"
                        :clearable="true"
                        default-time="12:30:00"
                    />
                  </el-tooltip>  
                  <!-- 默认任务到期时间的24小时前 -->
                  <!-- default-time="timeDefaultShow" -->
              </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="流程图和表单库">
                    <el-tooltip  content="当前任务节点执行人是否能流程实例查看流程图和表单库" effect="light" placement="top">
                        <el-radio-group v-model="nodeInfo.execLog" size="mini">
                          <el-radio :label="0">允许查看</el-radio>
                          <el-radio :label="1">不允许查看</el-radio>
                      </el-radio-group>
                    </el-tooltip> 
                </el-form-item>
            </el-col>
        </el-row>
        <!-- <el-row>
            <el-col :span="12">
               <el-form-item label="任务难度分">
                  <el-tooltip  content="设置难度分后系统会自动统计相关分数，在运营中心可以看到任务相关指标" effect="light" placement="top">
                    <el-input-number v-model="nodeInfo.difficultScore" :min="0" :max="100" label="任务难度分"></el-input-number>
                  </el-tooltip>
              </el-form-item>
            </el-col>
            <el-col :span="12">
               <el-form-item label="任务难度级别">
                      <el-rate v-model="nodeInfo.difficultLevel" :colors="colors"></el-rate>
                </el-form-item>
            </el-col>
        </el-row> -->
        <el-row>
            <el-col :span="12">
                <el-form-item label="任务文件权限">
                    <el-tooltip  content="当前任务节点上传的文件是否允许在我的流程中的文件列表中可见" effect="light" placement="top">
                        <el-radio-group v-model="nodeInfo.fileAuth" size="mini">
                            <el-radio :label="0">允许流程可见</el-radio>
                            <el-radio :label="1">不允许流程可见</el-radio>
                        </el-radio-group>
                    </el-tooltip> 
                </el-form-item>
                <el-form-item label="表单文件能否删除">
                    <el-tooltip  content="当前任务节点表单上传的文件是否允许删除，如果允许删除即便没有删除权限也可以删除文件" effect="light" placement="top">
                        <el-radio-group v-model="nodeInfo.deleteFileAuth" size="mini">
                            <el-radio :label="0">不允许删除</el-radio>
                            <el-radio :label="1">允许删除</el-radio>
                        </el-radio-group>
                    </el-tooltip> 
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="自动完成任务">
                    <el-tooltip  content="当前任务节点是否可以自动完成？选择是，则流程流转到当前任务后，系统会将该任务自动完成" effect="light" placement="top">
                        <el-radio-group v-model="nodeInfo.autoCompleteFlag" size="mini">
                            <el-radio :label="0">否</el-radio>
                            <el-radio :label="1">是</el-radio>
                        </el-radio-group>
                    </el-tooltip> 
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
                <el-form-item label="更新历史数据">
                    <el-tooltip  content="当前任务节点是否是修改历史流程任务表单数据？选择是，则当前任务需要从历史应用数据中选择数据。" effect="light" placement="top">
                        <el-radio-group v-model="nodeInfo.updHisProcessDataFlag" size="mini">
                            <el-radio :label="0">否</el-radio>
                            <el-radio :label="1">是</el-radio>
                        </el-radio-group>
                    </el-tooltip> 
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="支持手机端完成">
                    <el-tooltip  content="当前任务节点是否支持手机端完成任务？选择是，则该任务可以在手机端进行完成操作。默认否" effect="light" placement="top">
                        <el-radio-group v-model="nodeInfo.canbyMobile" size="mini">
                            <el-radio :label="0">否</el-radio>
                            <el-radio :label="1">是</el-radio>
                        </el-radio-group>
                    </el-tooltip> 
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
                <el-form-item label="不同步应用表单">
                    <el-tooltip  content="当前任务无论是驳回还是完成都不同步到应用表单里。" effect="light" placement="top">
                        <el-radio-group v-model="nodeInfo.unSynAppForm" size="mini">
                            <el-radio :label="0">否</el-radio>
                            <el-radio :label="1">是</el-radio>
                        </el-radio-group>
                    </el-tooltip> 
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="驳回不同步应用表单">
                    <el-tooltip  content="与不同步应用表单结合使用，在不同步应用表单设置为否的情况下，当前任务节点表单在任务驳回时不同步到应用表单里。" effect="light" placement="top">
                        <el-radio-group v-model="nodeInfo.unSynAppFormByReject" size="mini">
                            <el-radio :label="0">否</el-radio>
                            <el-radio :label="1">是</el-radio>
                        </el-radio-group>
                    </el-tooltip> 
                </el-form-item>
            </el-col>
        </el-row>
        <el-form-item label="任务执行说明">
        <!-- style="width:99%;overflow-x:hidden;"  -->
            <el-input
                type="textarea"
                
                :autosize="{ minRows: 3, maxRows: 5}"
                placeholder="请输入内容"
                v-model="nodeInfo.desc">
            </el-input>
        </el-form-item>
        <!--任务摘要配置begin-->
        <el-row>
            <el-col>
                <el-form-item label="任务摘要配置">
                    <el-tooltip  content="当前任务的表单的字段数据组合作为任务摘要显示。" effect="light" placement="top">
                        <el-radio-group  v-model="nodeInfo.taskRemarkFlag" size="mini">
                            <el-radio :label="0">否</el-radio>
                            <el-radio :label="1">是</el-radio>
                        </el-radio-group>
                    </el-tooltip>
                </el-form-item>
            </el-col>
        </el-row>
        <el-form-item  v-if="nodeInfo.taskRemarkFlag===1" label="关联关系配置">
            <div class="form-data-link-config">
                <el-row>
                    <el-col :span="12" >
                        <div class="process-data-link-config-opera">
                            <el-button type="primary" @click="addTaskRemarkLinkData">新增关联关系</el-button>
                        </div>
                    </el-col>
                </el-row>
                <el-row v-for="(obj,index) in taskRemarkList" :key="index">
                    <el-col :span="5" >
                        <el-form-item label="任务表单">
                            <el-select v-model="obj.sourceTaskFormIdStr" placeholder="请选择任务表单" class="triggerSource" @change="changeCurTaskForm5(obj)">
                                <el-option
                                    v-for="item in allTaskFormList"
                                    :key="item.id+item.taskId+item.taskName"
                                    :label="'['+item.taskName+']-'+item.formName"
                                    :value="item.id+'#'+item.taskId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5" >
                        <el-form-item label="任务表单字段">
                            <el-select v-model="obj.sourceFormFieldId" placeholder="请选择关联字段" class="triggerSource" @change="changeFormFieldId5(obj)">
                                <el-option
                                    v-for="item in obj.sourceFieldList"
                                    :key="item.id+item.name"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4" >
                        <div class="opear-delete"><i class="el-icon-delete" @click="deleteTaskRemarkLinkData(obj)"></i></div>
                    </el-col>
                </el-row>
            </div>
        </el-form-item>
        <!--任务摘要配置end-->
            <el-row>
                <el-col :span="8">
                   <el-form-item label="是否为审批节点">
                        <el-tooltip  content="当前任务节点是否需要发起指定的审批流，需要则设置审批流模板，同时审批流执行通过时当前任务才能到达下一任务节点" effect="light" placement="top">
                            <el-radio-group v-model="nodeInfo.isApproval" size="mini">
                                <el-radio :label="0">否</el-radio>
                                <el-radio :label="1">是</el-radio>
                            </el-radio-group>
                        </el-tooltip> 
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                   <el-form-item v-if="nodeInfo.isApproval===1" label="必须发起审批">
                        <el-tooltip  content="任务下的审批流模板，选择是必须发起,选择否可不发起。" effect="light" placement="top">
                            <el-radio-group  v-model="nodeInfo.canUnStartApproval" size="mini">
                                <el-radio :label="0">是</el-radio>
                                <el-radio :label="1">否</el-radio>
                            </el-radio-group>
                        </el-tooltip>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                   <el-form-item v-if="nodeInfo.isApproval===1" label="取消提醒">
                        <el-tooltip  content="打开任务详情，若需审批流，无需提醒并切换到审批流tab页签" effect="light" placement="top">
                            <el-radio-group  v-model="nodeInfo.cancelApprovalRemind" size="mini">
                                <el-radio :label="0">否</el-radio>
                                <el-radio :label="1">是</el-radio>
                            </el-radio-group>
                        </el-tooltip>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                   <el-form-item v-if="nodeInfo.isApproval===1" label="可重复发起">
                        <el-tooltip  content="默认可重复发起多条审批，选择否，则只能发起一条(驳回的流程除外)。" effect="light" placement="top">
                            <el-radio-group  v-model="nodeInfo.onlyOneApproval" size="mini">
                                <el-radio :label="0">是</el-radio>
                                <el-radio :label="1">否</el-radio>
                            </el-radio-group>
                        </el-tooltip>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                   <el-form-item v-if="nodeInfo.isApproval===1" label="通过自动完成任务">
                        <el-tooltip  content="审批流通过后自动完成当前任务" effect="light" placement="top">
                            <el-radio-group  v-model="nodeInfo.autoCompleteByApproval" size="mini">
                                <el-radio :label="0">否</el-radio>
                                <el-radio :label="1">是</el-radio>
                            </el-radio-group>
                        </el-tooltip>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                   <el-form-item v-if="nodeInfo.isApproval===1" label="仅保留最新数据">
                        <el-tooltip  content="是否只保留最新的审批流表单数据。若选择是，同一审批流模板发起多条，则在应用表单处只保留一条数据。若选择否，则在应用表单处保留所有审批流表单数据。默认否。" effect="light" placement="top">
                            <el-radio-group  v-model="nodeInfo.onlyLastFormData" size="mini">
                                <el-radio :label="0">否</el-radio>
                                <el-radio :label="1">是</el-radio>
                            </el-radio-group>
                        </el-tooltip>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item  v-if="nodeInfo.isApproval===1">
                <el-button type="success" icon="el-icon-sort" @click="handleChooseApproval" title='选择审批流' round>选择审批流</el-button>
            </el-form-item> 

          <el-form-item  v-if="nodeInfo.isApproval===1" label="关联审批流">
              <el-table :data="nodeInfo.approvalTemplateList" :border="true" height="130" style="margin-top:-10px;overflow-y:auto">
                  <el-table-column
                    label="模板名称"
                    :show-overflow-tooltip="true"
                    align="center"
                    width="100">
                    <template slot-scope="scope">
                        <span style="font-weight: 700;color:#303133;font-size:16px;">{{ scope.row.templateName }}</span>
                    </template>
                  </el-table-column>
                   <el-table-column
                      prop="busiTypeName"
                      width="100"
                      label="审批类型"
                      align="center"
                    >
                  </el-table-column>
                  <el-table-column
                    label="审批流顺序"
                    align="center"
                    >
                    <template slot-scope="scope">
                        <!--<el-steps v-if="scope.row.approvalTotalNum>0" :active="scope.row.approvalTotalNum" align-center>
                          <el-step v-for="(item, index) in scope.row.users" :key="index" :title="item.trueName"></el-step>
                        </el-steps>-->
                        <el-steps v-if="scope.row.approvalMethod != 2 && scope.row.approvalTotalNum>0" :active="scope.row.approvalTotalNum" align-center>
                            <el-step v-for="(item, index) in scope.row.users" :key="index" :title="item.trueName"></el-step>
                        </el-steps>
                        <el-steps v-if="scope.row.approvalMethod == 2 && scope.row.approvalTotalNum>0" :active="scope.row.approvalTotalNum" align-center>
                            <el-step v-for="(item, index) in scope.row.approvalList"  :key="index" align-center >
                                <el-breadcrumb v-if="item && item.length > 0" slot="title" :separator="(scope.row.approvalUserGroupList[index].approvalMultiSignType == 2?'+':'/')">
                                    <el-breadcrumb-item  v-for="(user, i) in item" :key="i">{{user.trueName}}</el-breadcrumb-item>
                                </el-breadcrumb>
                            </el-step>
                        </el-steps>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="操作" fixed="right" width="115">
                    <template slot-scope="scope">
                      <el-button size="mini" style="margin-left:-6px" icon="el-icon-view" title="预览" circle @click="handleViewTemplate(scope.row)"></el-button>
                      <el-button type="danger" size="mini" icon="el-icon-delete" title="删除" circle @click="handleDelete(scope.$index,scope.row)"></el-button>
                    </template>
                  </el-table-column>
                </el-table>
          </el-form-item>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="是否为业务流节点">
                        <el-tooltip  content="当前任务节点是否需要发起指定的业务流，需要则设置业务流模板" effect="light" placement="top">
                            <el-radio-group  v-model="nodeInfo.isSubProcess" size="mini">
                                <el-radio :label="0">否</el-radio>
                                <el-radio :label="1">是</el-radio>
                            </el-radio-group>
                        </el-tooltip>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                   <el-form-item v-if="nodeInfo.isSubProcess===1" label="完成所有子流程">
                        <el-tooltip  content="任务下的子流程必须全部完成才可完成当前任务" effect="light" placement="top">
                            <el-radio-group  v-model="nodeInfo.needAllSubProcess" size="mini">
                                <el-radio :label="0">否</el-radio>
                                <el-radio :label="1">是</el-radio>
                            </el-radio-group>
                        </el-tooltip>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item  v-if="nodeInfo.isSubProcess===1">
                <el-button type="success" icon="el-icon-sort" @click="handleChooseProcess" title='选择业务流' round>选择业务流</el-button>
            </el-form-item>  
            <el-form-item  v-if="nodeInfo.isSubProcess===1" label="关联业务流">
                <el-table :data="nodeInfo.subProcesslTemplateList" :border="true" height="130" style="margin-top:-10px;overflow-y:auto">
                    <el-table-column
                        label="流程模板名称"
                        :show-overflow-tooltip="true"
                        align="center"
                        >
                        <template slot-scope="scope">
                            <span style="font-weight: 700;color:#303133;font-size:16px;">{{ scope.row.subProcessTemplateName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="版本号"
                        :show-overflow-tooltip="true"
                        align="center"
                        width="80">
                        <template slot-scope="scope">
                            v{{scope.row.subProcessTemplateVersion}}
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="操作" fixed="right" width="115">
                        <template slot-scope="scope">
                        <el-button size="mini" style="margin-left:-6px" icon="el-icon-view" title="预览" circle @click="handleViewProcessTemplate(scope.row)"></el-button>
                        <el-button type="danger" size="mini" icon="el-icon-delete" title="删除" circle @click="handleDeleteProcessTemplate(scope.$index,scope.row)"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form-item>
        <!--表单级联控制配置begin-->
        <el-row>
            <el-col>
                <el-form-item label="表单显示控制">
                    <el-tooltip  content="当前任务显示的表单受上级任务表单选项值的控制。默认否，若选择是，则需要配置当前表单与上级任务表单选项的映射关系。" effect="light" placement="top">
                        <el-radio-group  v-model="nodeInfo.supTaskformCtr" size="mini">
                            <el-radio :label="0">否</el-radio>
                            <el-radio :label="1">是</el-radio>
                        </el-radio-group>
                    </el-tooltip>
                </el-form-item>
            </el-col>
        </el-row>
        <el-form-item  v-if="nodeInfo.supTaskformCtr===1" label="映射关系配置">
            <div class="form-data-link-config">
                <el-row>
                    <!-- <el-col :span="12" >
                        <div class="process-data-link-config-sourceMethod">
                            <el-form size="mini" ref="sourceMethodForms">
                                <el-form-item label="数据源">
                                    <el-select v-model="sourceMethod" placeholder="请选择数据源" class="triggerSource" @change="changeSourceMethod">
                                        <el-option
                                            v-for="item in sourceMethods"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-form>
                        </div>
                    </el-col> -->
                    <el-col :span="12" >
                        <div class="process-data-link-config-opera">
                            <el-button type="primary" @click="addLinkData">新增映射关系</el-button>
                        </div>
                    </el-col>
                </el-row>
                <el-row v-for="(obj,index) in linkData" :key="index">
                    <el-col :span="5" >
                        <el-form-item label="源任务表单">
                            <el-select v-model="obj.sourceTaskFormIdStr" placeholder="请选择源任务表单" class="triggerSource" @change="changeSourceForm(obj)">
                                <el-option
                                    v-for="item in sourceFormList"
                                    :key="item.id+item.taskId"
                                    :label="'['+item.taskName+']-'+item.formName"
                                    :value="item.id+'#'+item.taskId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                     <el-col :span="5" >
                        <el-form-item label="表单字段">
                            <el-select v-model="obj.sourceFieldId" placeholder="请选择选项字段" class="triggerSource" @change="changeSourceField(obj)">
                                <el-option
                                    v-for="item in obj.sourceFieldList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                     <el-col :span="5" >
                        <el-form-item label="选项值">
                            <el-select v-model="obj.sourceFileldOptionKey" placeholder="请选择数据源" class="triggerSource" @change="changeSourceOption(obj)">
                                <el-option
                                    v-for="item in obj.sourceOptionList"
                                    :key="item.value"
                                    :label="item.title"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                     <el-col :span="5" >
                        <el-form-item label="当前任务表单">
                            <el-select v-model="obj.formId" placeholder="请选择数据源" class="triggerSource" @change="changeTargetForm(obj)">
                                <el-option
                                    v-for="item in targetFormList"
                                    :key="item.id"
                                    :label="item.formName"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4" >
                         <div class="opear-delete"><i class="el-icon-delete" @click="deleteLinkData(obj)"></i></div>
                    </el-col>
                </el-row>
            </div>
        </el-form-item>
        <!--表单级联控制配置end-->
        <!--表单同步任务负责人配置begin-->
        <el-row>
            <el-col>
                <el-form-item label="表单同步负责人">
                    <el-tooltip  content="当前任务的表单的关联字段的关联数据中的字段名为【一审】的用户值可以同步流程内任务名为【一审】的负责人。" effect="light" placement="top">
                        <el-radio-group  v-model="nodeInfo.synTaskAssigneeFlag" size="mini">
                            <el-radio :label="0">否</el-radio>
                            <el-radio :label="1">是</el-radio>
                        </el-radio-group>
                    </el-tooltip>
                </el-form-item>
            </el-col>
        </el-row>
        <el-form-item  v-if="nodeInfo.synTaskAssigneeFlag===1" label="关联关系配置">
            <div class="form-data-link-config">
                <el-row>
                    <el-col :span="12" >
                        <div class="process-data-link-config-opera">
                            <el-button type="primary" @click="addSynAssignUserLinkData">新增关联关系</el-button>
                        </div>
                    </el-col>
                </el-row>
                <el-row v-for="(obj,index) in synAssignUserLink" :key="index">
                    <el-col :span="5" >
                        <el-form-item label="当前任务表单">
                            <el-select v-model="obj.taskFormIdStr" placeholder="请选择任务表单" class="triggerSource" @change="changeCurTaskForm(obj)">
                                <el-option
                                    v-for="item in curTaskFormList"
                                    :key="item.formId+item.taskId"
                                    :label="'['+item.taskName+']-'+item.formName"
                                    :value="item.formId+'#'+item.taskId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                     <el-col :span="5" >
                        <el-form-item label="任务表单字段">
                            <el-select v-model="obj.formFieldId" placeholder="请选择关联字段" class="triggerSource" @change="changeFormFieldId(obj)">
                                <el-option
                                    v-for="item in obj.formFieldIdList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                     <el-col :span="5" v-if="obj.formFieldType && obj.formFieldType === 'link'">
                        <el-form-item label="关联表单字段">
                            <el-select v-model="obj.linkFormFieldId" placeholder="请选择关联的表单的字段" class="triggerSource" @change="changeLinkFormFieldId(obj)">
                                <el-option
                                    v-for="item in obj.linkFormFieldIdList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                     <el-col :span="5" >
                        <el-form-item label="关联的任务">
                            <el-select v-model="obj.targetTaskId" placeholder="请选择关联的任务" class="triggerSource" @change="changeTargetTask(obj)">
                                <el-option
                                    v-for="item in targetTaskList"
                                    :key="item.id"
                                    :label="item.taskName"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4" >
                         <div class="opear-delete"><i class="el-icon-delete" @click="deleteSynAssignUserLinkData(obj)"></i></div>
                    </el-col>
                </el-row>
            </div>
        </el-form-item>
        <!--表单同步任务负责人配置end-->
        <!--表单同步修改会签任务负责人begin-->
        <el-row>
            <el-col>
                <el-form-item label="任务自动启动">
                    <el-tooltip  content="任务自动启动【针对当前流程模板后续的会签任务及含子流程的任务】：选择当前任务的表单的子表单字段，取出子表单人员类型字段的值级联修改下一任务（会签）负责人，假如配置了子流程则启动子流程。" effect="light" placement="top">
                        <el-radio-group  v-model="nodeInfo.updCountersigTaskFlag" size="mini">
                            <el-radio :label="0">否</el-radio>
                            <el-radio :label="1">是</el-radio>
                        </el-radio-group>
                    </el-tooltip>
                </el-form-item>
            </el-col>
        </el-row>
        <el-form-item  v-if="nodeInfo.updCountersigTaskFlag===1" label="关联关系配置">
            <div class="form-data-link-config">
                <el-row>
                    <el-col :span="12" >
                        <div class="process-data-link-config-opera">
                            <el-button type="primary" @click="addNextNodeAssigneerLinkData">新增关联关系</el-button>
                        </div>
                    </el-col>
                </el-row>
                <el-row v-for="(obj,index) in updCountersigTaskList" :key="index+subProcessListTime">
                    <el-col :span="5" >
                        <el-form-item label="当前任务表单">
                            <el-select v-model="obj.taskFormIdStr" placeholder="请选择任务表单" class="triggerSource" @change="changeCurTaskForm2(obj)">
                                <el-option
                                    v-for="item in curTaskFormList"
                                    :key="item.formId+item.taskId"
                                    :label="'['+item.taskName+']-'+item.formName"
                                    :value="item.formId+'#'+item.taskId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                     <el-col :span="5" >
                        <el-form-item label="任务表单字段">
                            <el-select v-model="obj.formFieldId" :key="subFormFieldIdTime" placeholder="请选择当前表单的子表单类型字段" class="triggerSource" @change="changeFormFieldId2(obj)">
                                <el-option
                                    v-for="item in obj.formFieldIdList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                     <el-col :span="5" >
                        <el-form-item label="子表单用户字段">
                            <el-select v-model="obj.subFormFieldId" :key="subFormFieldIdTime" placeholder="请选择子表单的用户字段" class="triggerSource" @change="changeSubFieldId2(obj)">
                                <el-option
                                    v-for="item in obj.subFormFieldIdList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7" >
                        <el-form-item  style="margin-left:-3%" label="关联的任务">
                            <el-select v-model="obj.targetTaskId" :key="subFormFieldIdTime" placeholder="请选择关联的任务" class="triggerSource" @change="changeTargetTask2">
                                <el-option
                                    v-for="item in targetTaskList"
                                    :key="item.id"
                                    :label="item.taskName"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                            <el-tooltip  v-if="obj.subProcessList!==undefined && obj.subProcessList.length > 0"  content="当前任务包含子流程，可以选择子流程自动启动设置" effect="light" placement="left">
                              <el-select   v-model="obj.subProcessTemplateId"  placeholder="请选择启动的子流程" class="triggerSource" @change="changeSubprocess(obj)" >
                                  <el-option
                                      v-for="item in obj.subProcessList"
                                      :key="item.id"
                                      :label="item.subProcessTemplateName"
                                      :value="item.subProcessServiceId+','+item.subDeploymentId">
                                  </el-option>
                              </el-select>
                            </el-tooltip>
                            <el-tooltip  v-if="obj.subProcessList!==undefined && obj.subProcessList.length > 0"  content="子流程名称默认规则为：主流程名称+子流程模板名称.可以根据子表单字段，选择设置子流程启动时默认名称，选择字段后子流程名称为：主流程名称+子表单字段值" effect="light" placement="left">
                              <el-select v-model="obj.subProcessNameFieldId"  placeholder="请选择设置子流程名称的字段" class="triggerSource" @change="refreshTaskFormNextNodeAssigneerList">
                                  <el-option
                                      v-for="item in obj.subFormFieldIdListAll" 
                                      :key="item.id"
                                      :label="item.name"
                                      :value="item.id">
                                  </el-option>
                              </el-select>
                            </el-tooltip>
                        <!-- <el-button v-if="obj.subProcessList!==undefined && obj.subProcessList.length > 0" :key="subProcessListTime"  type="primary" size="mini" icon="el-icon-setting" title="设置自动启动子流程相关配置"  circle @click="handleSettingSubProcess(obj.subProcessTemplateId)"></el-button> -->
                        </el-form-item>
                    </el-col>
                    <el-col :span="2" >
                      <div class="opear-delete"><i class="el-icon-delete" @click="deleteNextNodeAssigneerLinkData(obj)"></i></div>
                      <el-button v-if="obj.subProcessList!==undefined && obj.subProcessList.length > 0"  size="mini" icon="el-icon-view" title="预览子流程"  circle @click="handleViewSubProcess(obj)"></el-button>
                    </el-col>
                </el-row>
            </div>
        </el-form-item>
        <!--表单同步任务负责人配置end-->

        <!--表单控制按钮显示begin-->
        <el-row>
            <el-col>
                <el-form-item label="表单控制按钮显示">
                    <el-tooltip  content="当前任务的表单的选项或数字值控制其他任务节点按钮显示。" effect="light" placement="top">
                        <el-radio-group  v-model="nodeInfo.synTaskBtnFlag" size="mini">
                            <el-radio :label="0">否</el-radio>
                            <el-radio :label="1">是</el-radio>
                        </el-radio-group>
                    </el-tooltip>
                </el-form-item>
            </el-col>
        </el-row>
        <el-form-item  v-if="nodeInfo.synTaskBtnFlag===1" label="关联关系配置">
            <div class="form-data-link-config">
                <el-row>
                    <el-col :span="12" >
                        <div class="process-data-link-config-opera">
                            <el-button type="primary" @click="addOtherNodeBtnLinkData">新增关联关系</el-button>
                        </div>
                    </el-col>
                </el-row>
                <el-row v-for="(obj,index) in synTaskBtnList" :key="index">
                    <el-col :span="4" >
                        <el-form-item label="当前任务表单">
                            <el-select v-model="obj.taskFormIdStr" placeholder="请选择任务表单" class="triggerSource" @change="changeCurTaskForm3(obj)">
                                <el-option
                                    v-for="item in curTaskFormList"
                                    :key="item.formId+item.taskId"
                                    :label="'['+item.taskName+']-'+item.formName"
                                    :value="item.formId+'#'+item.taskId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                     <el-col :span="4" >
                        <el-form-item label="表单字段">
                            <el-select v-model="obj.formFieldId" placeholder="请选择当前表单的字段" class="triggerSource" @change="changeFormFieldId3(obj)">
                                <el-option
                                    v-for="item in obj.formFieldIdList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" >
                        <el-form-item v-if="obj.formFieldType && obj.formFieldType==='number'" label="比较条件">
                            <el-row>
                                <el-col :span="12" >
                                    <el-select v-model="obj.optCondition" placeholder="请选择比较条件" class="triggerSource" @change="changeformFieldKey(obj)">
                                        <el-option
                                            v-for="item in optConditionList"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-col>
                                <el-col :span="10" > 
                                    <el-input-number v-model="obj.formFieldValue" controls-position="right" @change="changeformFieldKey"></el-input-number>
                                </el-col>
                            </el-row>    
                        </el-form-item>
                        <el-form-item v-else label="字段选项">
                            <el-select v-model="obj.formFieldKey" placeholder="请选择当前表单的字段的选项" class="triggerSource" @change="changeformFieldKey(obj)">
                                <el-option
                                    v-for="item in obj.formFieldKeyList"
                                    :key="item.value"
                                    :label="item.title"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4" >
                        <el-form-item label="目标任务">
                            <el-select v-model="obj.targetTaskId" placeholder="请选择关联的任务" class="triggerSource" @change="changeTargetTask3(obj)">
                                <el-option
                                    v-for="item in targetTaskList"
                                    :key="item.id"
                                    :label="item.taskName"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                     <el-col :span="4" >
                        <el-form-item label="任务按钮">
                            <el-select v-model="obj.targetTaskBtnId" placeholder="请选择关联的任务按钮" class="triggerSource" @change="changeTargetTaskBtn(obj)">
                                <el-option
                                    v-for="item in obj.targetTaskBtnList"
                                    :key="item.operateType"
                                    :label="item.operateName"
                                    :value="item.operateType">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="2" >
                         <div class="opear-delete"><i class="el-icon-delete" @click="deleteOtherNodeBtnLinkData(obj)"></i></div>
                    </el-col>
                </el-row>
            </div>
        </el-form-item>
        <!--表单控制按钮显示end-->

        <!--表单审批配置begin-->
        <el-row>
            <el-col>
                <el-form-item label="表单审批配置">
                    <el-tooltip  content="通过当前任务的表单的选项选择需要用到的审批流模板" effect="light" placement="top">
                        <el-radio-group  v-model="nodeInfo.formApprovalFlag" size="mini">
                            <el-radio :label="0">否</el-radio>
                            <el-radio :label="1">是</el-radio>
                        </el-radio-group>
                    </el-tooltip>
                </el-form-item>
            </el-col>
        </el-row>
        <el-form-item  v-if="nodeInfo.formApprovalFlag===1" label="关联关系配置">
            <div class="form-data-link-config">
                <el-row>
                    <el-col :span="12" >
                        <div class="process-data-link-config-opera">
                            <el-button type="primary" @click="addFormApprovalLinkData">新增关联关系</el-button>
                        </div>
                    </el-col>
                </el-row>
                <el-row v-for="(obj,index) in formApprovalList" :key="index">
                    <el-col :span="4" >
                        <el-form-item label="当前任务表单">
                            <el-select v-model="obj.taskFormIdStr" placeholder="请选择任务表单" class="triggerSource" @change="changeCurTaskForm4(obj)">
                                <el-option
                                    v-for="item in curTaskFormList"
                                    :key="item.formId+item.taskId"
                                    :label="'['+item.taskName+']-'+item.formName"
                                    :value="item.formId+'#'+item.taskId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                     <el-col :span="4" >
                        <el-form-item label="表单字段">
                            <el-select v-model="obj.formFieldId" placeholder="请选择当前表单的字段" class="triggerSource" @change="changeFormFieldId4(obj)">
                                <el-option
                                    v-for="item in obj.formFieldIdList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" >
                        <el-form-item label="字段选项">
                            <template v-if="obj.formFieldType === 'department'">
                                <Department
                                    ref="deptTreeChild"
                                    :multiple="true"
                                    :selectedNode="obj.departmentBO"
                                    :currentPK="obj.id"
                                    :popover="true"
                                    :ifFiltDataSource="true"
                                    @nodeClick="handleDeptTreeNode"
                                />
                            </template>
                            <template v-else>
                              <el-select v-model="obj.formFieldKey" placeholder="请选择当前表单的字段的选项" class="triggerSource" @change="changeformFieldKey2(obj)">
                                <el-option
                                    v-for="item in obj.formFieldKeyList"
                                    :key="item.value"
                                    :label="item.title"
                                    :value="item.value">
                                </el-option>
                              </el-select>
                            </template>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4" >
                        <el-form-item label="审批流模板">
                            <el-select v-model="obj.approvalTemplateId" placeholder="请选择关联的任务" class="triggerSource" @change="changeTargetApproval(obj)">
                                <el-option
                                    v-for="item in nodeInfo.approvalTemplateList"
                                    :key="item.id"
                                    :label="item.templateName"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="2" >
                         <div class="opear-delete"><i class="el-icon-delete" @click="deleteFormApprovalLinkData(obj)"></i></div>
                    </el-col>
                </el-row>
            </div>
        </el-form-item>
        <!--表单审批配置end-->
    </el-form>
     <el-dialog
          width="90%"
          top="1vh"
          :visible.sync="isShowApprovalTemplate"
          append-to-body >
              <ApprovalTemplate ref="approvalTemplate" :isSelect="true" @closeApprovalTemplate="closeApprovalTemplate" @chooseApprovalTemplate="chooseApprovalTemplate"/>
              <span slot="footer" class="dialog-footer">
                  <el-button @click="isShowApprovalTemplate = false">取 消</el-button>
                  <el-button type="primary" @click="chooseApproval()">选 择</el-button>
              </span>
      </el-dialog> 

      <el-dialog
          width="90%"
          top="1vh"
          :visible.sync="isShowProcessTemplate"
          append-to-body >
              <ProcessTemplate class="subProcess" ref="processTemplate" :hiddenReturn="true" :isDialogChoose="true" :callActivityConfig="callActivityConfig" :isMulti="true" /> 
              <span slot="footer" class="dialog-footer">
                  <el-button @click="isShowProcessTemplate = false">取 消</el-button>
                  <el-button type="primary" @click="chooseSubProcess()">选 择</el-button>
              </span>
      </el-dialog> 
      <el-dialog
          title="审批流模板"
          width="80%"
          top="1vh"
          :visible.sync="isShowTemplate"
          append-to-body
          >
          <ApprovalTemplatePop ref="approvalTemplatePop" :templateInfo="templateInfo" :isRead="true"/>
          <span slot="footer" class="dialog-footer">
              <el-button @click="isShowTemplate=false">取 消</el-button>
          </span>
      </el-dialog> 
      <el-dialog
            title="流程明细"
            :fullscreen=true
            append-to-body
            :visible.sync="isShowDiagram"
            custom-class="diagram-dialog">
            <ProcessDetailView ref="detailView" :viewParams="viewParams" />
        </el-dialog>
  </div>
</template>

<script>
    import { isEmpty, cloneDeep } from 'lodash';
    import ApprovalTemplate from '@/pages/process/ProcessTemplate/ApprovalTemplate';
    import ApprovalTemplatePop from '@/pages/process/ProcessTemplate/ApprovalTemplatePop';
    import ProcessTemplate from '@/pages/process/ProcessTemplate/ProcessTemplate';
    import ProcessDetailView from '@/pages/process/ProcessList/ProcessDetailView';
    import {getServiceTasks, getProcessServiceConfig, getFormConfig, getProcessServiceTaskForms, getAllProcessTaskForms} from '@/data-model';
    export default {
        components: {
            ApprovalTemplate,
            ApprovalTemplatePop,
            ProcessTemplate,
            ProcessDetailView
        },
        data () {
            return {
                subFormFieldIdTime: '',
                subProcessListTime: '',
                allTaskFormList: [],
                taskRemarkList: [],
                // begin
                formApprovalList: [], // end
                // begin
                optConditionList: [{
                    value: 0,
                    label: '等于'
                }, {
                    value: 1,
                    label: '大于'
                }, {
                    value: 2,
                    label: '大于等于'
                }, {
                    value: 3,
                    label: '小于'
                }, {
                    value: 4,
                    label: '小于等于'
                }],
                synTaskBtnList: [], // end
                // begin
                updCountersigTaskList: [], // end
                // begin
                curTaskFormList: [],
                targetTaskList: [],
                synAssignUserLink: [], // end
                // begin
                loadTimer: '',
                sourceFormList: [],
                targetFormList: [],
                linkData: [], // end
                //  timeDefaultShow: this.getAfter7Day()
                colors: ['#99A9BF', '#FFDC35', '#FF9900'],
                isShowAddSDays: isEmpty(this.nodeInfo.planStartTime),
                isShowAddEDays: isEmpty(this.nodeInfo.planEndTime),
                isShowApprovalTemplate: false,
                isShowProcessTemplate: false,
                isShowDiagram: false,
                viewParams: {},
                multipleSelection: [],
                // approvalTemplateList: [],
                isShowTemplate: false,
                templateInfo: {
                    id: '',
                    templateName: '',
                    busiType: '',
                    busiTypeName: '',
                    remarks: '',
                    selectedUser: {
                        selectedUserIds: '',
                        selectedUserNames: ''
                    },
                    templateState: null,
                    forms: [],
                    users: [],
                    dataOperate: {
                        dataSource: 2,
                        forms: []
                    },
                    approvalMethod: 1, // 审批方法，1:普通审批，2:审批流节点或签审批
                    showAllMyApprovals: true
                },
                callActivityConfig: {
                    processServiceId: '',
                    deploymentId: '',
                    callActivityId: '',
                    callActivityName: '',
                    calledElement: '',
                    calledElementProcessDefinitionId: '',
                    calledElementProcessServiceId: '',
                    calledElementDeploymentId: '',
                    templateName: '',
                    viewOrder: 0
                }
            };
        },
        props: {
            taskData: {
                type: Object
            },
            processInstance: {
                type: Object
            },
            nodeInfo: {
                type: Object
            },
            element: {
                type: Object
            }
        },
        created () {
            // console.log(this.nodeInfo);
            // if (isEmpty(this.nodeInfo.planStartDate)) {
            //     this.isShowAddSDays = true;
            // } else {
            //     this.isShowAddSDays = false;
            // }
            // if (isEmpty(this.nodeInfo.dueDate)) {
            //     this.isShowAddEDays = true;
            // } else {
            //     this.isShowAddEDays = false;
            // }
    
            if (!this.nodeInfo.addSDays || this.nodeInfo.addSDays === '') {
                this.nodeInfo.addSDays = 1;
            }
            if (!this.nodeInfo.addSDays || this.nodeInfo.addSDays === '') {
                this.nodeInfo.addEDays = 3;
            }
            // 表单显示映射关系配置
            if (this.nodeInfo.taskFormCascadeShowBOList && this.nodeInfo.taskFormCascadeShowBOList.length > 0) {
                this.linkData = cloneDeep(this.nodeInfo.taskFormCascadeShowBOList);
            } else {
                this.nodeInfo.taskFormCascadeShowBOList = [];
            }
            this.initSourceForms();

            // 表单关联字段同步任务负责人关系配置
            if (this.nodeInfo.synTaskAssigneeList && this.nodeInfo.synTaskAssigneeList.length > 0) {
                this.synAssignUserLink = cloneDeep(this.nodeInfo.synTaskAssigneeList);
            } else {
                this.nodeInfo.synTaskAssigneeList = [];
            }
            // console.log(this.synAssignUserLink);
            this.initCurTaskForms();
            this.getServiceTasks();
            // 表单字段修改会签任务负责人关系配置
            if (this.nodeInfo.updCountersigTaskList && this.nodeInfo.updCountersigTaskList.length > 0) {
                this.updCountersigTaskList = cloneDeep(this.nodeInfo.updCountersigTaskList);
            } else {
                this.nodeInfo.updCountersigTaskList = [];
            }
            this.initCurTaskForms2();

            // 表单字段控制其他任务按钮显示关系配置
            if (this.nodeInfo.synTaskBtnList && this.nodeInfo.synTaskBtnList.length > 0) {
                this.synTaskBtnList = cloneDeep(this.nodeInfo.synTaskBtnList);
            } else {
                this.nodeInfo.synTaskBtnList = [];
            }
            this.initCurTaskForms3();

            // 根据表单字段选项选择审批流模板
            if (this.nodeInfo.formApprovalList && this.nodeInfo.formApprovalList.length > 0) {
                this.formApprovalList = cloneDeep(this.nodeInfo.formApprovalList);
            } else {
                this.nodeInfo.formApprovalList = [];
            }
            this.initCurTaskForms4();

            // 任务摘要配置功能
            if (this.nodeInfo.taskRemarkList && this.nodeInfo.taskRemarkList.length > 0) {
                this.taskRemarkList = cloneDeep(this.nodeInfo.taskRemarkList);
            } else {
                this.nodeInfo.taskRemarkList = [];
            }
            this.initCurTaskForms5();
        },
        watch: {
            'nodeInfo' (newVal, oldVal) {
                // if (isEmpty(this.nodeInfo.addSDays)) {
                //    this.nodeInfo.addSDays = 1;
                // }
                // if (isEmpty(this.nodeInfo.addEDays)) {
                //    this.nodeInfo.addEDays = 3;
                // }
                if (isEmpty(this.nodeInfo.approvalTemplateList)) {
                    this.nodeInfo.approvalTemplateList = [];
                }
                // if (isEmpty(this.nodeInfo.isApproval)) {
                //     this.nodeInfo.isApproval = 0;
                // }
                if (isEmpty(this.nodeInfo.subProcesslTemplateList)) {
                    this.nodeInfo.subProcesslTemplateList = [];
                }
            },
            'nodeInfo.difficultLevel' (newVal, oldVal) {
                this.nodeInfo.difficultScore = newVal * 2;
            },
            'nodeInfo.planStartTime' (newVal, oldVal) {
                if (newVal !== null && newVal !== '') {
                    this.isShowAddSDays = false;
                } else {
                    this.isShowAddSDays = true;
                }
            },
            'nodeInfo.planEndTime' (newVal, oldVal) {
                if (newVal !== null && newVal !== '') {
                    this.isShowAddEDays = false;
                } else {
                    this.isShowAddEDays = true;
                }
            },
            'nodeInfo.subProcesslTemplateList' (newVal, oldVal) {
                if (this.nodeInfo.taskFormCascadeShowBOList && this.nodeInfo.taskFormCascadeShowBOList.length > 0) {
                    // this.linkData = this.nodeInfo.taskFormCascadeShowBOList;
                } else {
                    this.nodeInfo.taskFormCascadeShowBOList = [];
                }
            }
    
        },
        methods: {
            getAfter7Day () {
                const d = new Date();
                const after7d = d.getMonth() + '-' + (d.getDate() - 7) + ' ' + d.getHours() + ':' + d.getMinutes();
                return after7d;
            },
            handleChooseApproval () {
                this.isShowApprovalTemplate = true;
            },
            closeApprovalTemplate () { // 提供子组件调用
                this.isShowApprovalTemplate = false;
            },
            chooseApprovalTemplate (val) {
                this.multipleSelection = val;
            },
            chooseApproval () {
                if (isEmpty(this.multipleSelection)) {
                    this.$message({message: '请选择审批流模板', type: 'warning'});
                    return;
                }
                // console.log(this.multipleSelection);
                if (isEmpty(this.nodeInfo.approvalTemplateList)) {
                    this.nodeInfo.approvalTemplateList = [];
                }
                this.nodeInfo.approvalTemplateList = this.multipleSelection;
                this.isShowApprovalTemplate = false;
            },
            handleViewTemplate (row) {
                this.templateInfo = row;
                this.templateInfo.selectedUser = {};
                this.templateInfo.selectedUser.selectedUserIds = row.selectedUserIds;
                this.templateInfo.selectedUser.selectedUserNames = row.selectedUserNames;
    
                this.templateInfo.selectedCopyUser = {};
                this.templateInfo.selectedCopyUser.selectedUserIds = row.copyUserIds;
                this.templateInfo.selectedCopyUser.selectedUserNames = row.copyUserNames;
                this.templateInfo.countersignUsers = row.hasOwnProperty('countersignUsers') ? row.countersignUsers : [];
    
                setTimeout(() => { // 默认回显值
                    this.$refs.approvalTemplatePop._initPage();
                }, 0);
                this.isShowTemplate = true;
            },
            handleDelete (index, row) {
                // console.log(row);
                this.nodeInfo.approvalTemplateList.splice(index, 1);
            },
            handleChooseProcess () {
                this.isShowProcessTemplate = true;
            },
            chooseSubProcess () {
                // console.log(this.callActivityConfig);
                if (this.nodeInfo.isSubProcess === 1 && isEmpty(this.nodeInfo.subProcesslTemplateList) && isEmpty(this.callActivityConfig.calledElementProcessDefinitionId)) {
                    this.$message({message: '请选择业务流模板', type: 'warning'});
                    return;
                }
                // if (isEmpty(this.nodeInfo.subProcesslTemplateList)) {
                this.nodeInfo.subProcesslTemplateList = [];
                // }
                // setTimeout(() => {
                let arrTemplate = this.$refs.processTemplate.getSelectedProcessTemplate();
                // }, 0);
                if (!isEmpty(arrTemplate)) {
                    arrTemplate.forEach(item => {
                        // console.log(item);
                        let subProcessTemplate = {};
                        subProcessTemplate.localProcessDefinitionId = item.processDefinitionId;
                        // subProcessTemplate.processServiceId = this.callActivityConfig.processServiceId;
                        // subProcessTemplate.deploymentId = this.callActivityConfig.deploymentId;
                        subProcessTemplate.taskId = this.element.taskId;
                        subProcessTemplate.subProcessTemplateName = item.templateName;
                        subProcessTemplate.subProcessDefinitionId = item.id;
                        subProcessTemplate.subProcessServiceId = item.processServiceId;
                        subProcessTemplate.subDeploymentId = item.deploymentId;
                        subProcessTemplate.subProcessTemplateVersion = item.version;
                        subProcessTemplate.viewOrder = 0;
                        this.nodeInfo.subProcesslTemplateList.push(subProcessTemplate);
                    });
                }
                // let subProcessTemplate = {};
                // subProcessTemplate.localProcessDefinitionId = this.callActivityConfig.localProcessDefinitionId;
                // subProcessTemplate.processServiceId = this.callActivityConfig.processServiceId;
                // subProcessTemplate.deploymentId = this.callActivityConfig.deploymentId;
                // subProcessTemplate.taskId = this.element.taskId;
                // subProcessTemplate.subProcessTemplateName = this.callActivityConfig.templateName;
                // subProcessTemplate.subProcessDefinitionId = this.callActivityConfig.calledElementProcessDefinitionId;
                // subProcessTemplate.subProcessServiceId = this.callActivityConfig.calledElementProcessServiceId;
                // subProcessTemplate.subDeploymentId = this.callActivityConfig.calledElementDeploymentId;
                // subProcessTemplate.viewOrder = 0;
                // this.nodeInfo.subProcesslTemplateList.push(subProcessTemplate);
                this.isShowProcessTemplate = false;
            },
            handleViewProcessTemplate (row) {
                this.viewParams.id = row.localProcessDefinitionId;
                this.viewParams.pModelId = '';
                this.viewParams.viewDiagram = true;
                this.isShowDiagram = true;
                // console.log(this.viewParams);
                setTimeout(() => {
                    this.$refs.detailView.setProcessState(this.viewParams);
                }, 0);
                // this.isShowTemplate = true;
            },
    
            handleDeleteProcessTemplate (index, row) {
                // console.log(row);
                this.nodeInfo.subProcesslTemplateList.splice(index, 1);
            },
            // ==============配置表单关联映射beigin=======================
            async initSourceForms () {
                let tempFormsObj = null;
                if (this.processInstance) {
                    tempFormsObj = await getAllProcessTaskForms({// 查询流程实例对应的所有表单
                        processInstanceId: this.processInstance.id,
                        processServiceId: this.taskData.processServiceId,
                        deploymentId: this.taskData.deploymentId,
                        onlyThis: true
                    });
                } else {
                    tempFormsObj = await getProcessServiceTaskForms({// 查询流程模板对应的所有表单
                        processServiceId: this.taskData.processServiceId,
                        deploymentId: this.taskData.deploymentId,
                        time: new Date().getTime()
                    });
                }
                let currentTaskId = this.taskData.taskId;
                this.targetFormList = [];
                if (tempFormsObj && Array.isArray(tempFormsObj)) {
                    // let taskModeType = this.taskData.executor.modeType;
                    let repeatMap = new Map();
                    tempFormsObj.forEach(item => {
                        let objModelFormStructure = item.structure;
                        if (objModelFormStructure) {
                            objModelFormStructure.forEach(form => {
                                if (form.taskId === currentTaskId) {
                                    // 当前任务表单
                                    this.targetFormList.push(form);
                                } else { // 其他任务节点表单
                                    if (!repeatMap.has(form.id)) {
                                        this.sourceFormList.push(form);
                                        repeatMap.set(form.id, true);
                                    }
                                }
                            });
                        }
                    });
                }
                this.dealTaskFormCascadeShowBOList();
                // console.log(this.sourceFormList);
            },
            dealTaskFormCascadeShowBOList () {
                if (this.linkData && this.linkData.length > 0) {
                    this.linkData.forEach(item => {
                        // 初始化每一项的sourceFieldList，用于反显
                        item.sourceFieldList = [];
                        for (let i = 0; i < this.sourceFormList.length; i++) {
                            let obj = this.sourceFormList[i];
                            if (obj.id === item.sourceTaskFormId) {
                                obj.fieldsList.forEach(field => {
                                    if (field.type === 'category' || field.type === 'select') {
                                        if (field.options.config.type === 'single') {
                                            item.sourceFieldList.push(field);
                                        }
                                    }
                                });
                            }
                        }
                        // 初始化每一项的sourceOptionList，用于反显
                        item.sourceOptionList = [];
                        for (let i = 0; i < item.sourceFieldList.length; i++) {
                            let obj = item.sourceFieldList[i];
                            if (obj.id === item.sourceFieldId) {
                                item.sourceOptionList = cloneDeep(obj.options.config.options);
                                break;
                            }
                        }
                    });
                }
                this.refreshTaskFormCascadeShowBOList();
            },
            changeSourceForm (e) {
                this.sourceFieldList = [];
                // console.log(e);
                if (e) {
                    e.sourceTaskFormId = e.sourceTaskFormIdStr.split('#')[0];
                    e.sourceTaskId = e.sourceTaskFormIdStr.split('#')[1];
                    for (let i = 0; i < this.sourceFormList.length; i++) {
                        let obj = this.sourceFormList[i];
                        if (obj.id === e.sourceTaskFormId) {
                            e.sourceTaskFormName = obj.formName;
                            obj.fieldsList.forEach(field => {
                                if (field.type === 'category' || field.type === 'select') {
                                    if (field.options.config.type === 'single') {
                                        e.sourceFieldList.push(field);
                                    }
                                }
                            });
                        }
                    }
                }
                this.refreshTaskFormCascadeShowBOList();
            },
            changeSourceField (e) {
                this.sourceOptionList = [];
                // console.log(e);
                for (let i = 0; i < this.sourceFormList.length; i++) {
                    let obj = this.sourceFormList[i];
                    if (obj.id === e.sourceTaskFormId) {
                        for (let j = 0; j < obj.fieldsList.length; j++) {
                            let field = obj.fieldsList[j];
                            if (field.id === e.sourceFieldId) {
                                e.sourceOptionList = cloneDeep(field.options.config.options);
                            }
                        }
                    }
                }
                this.refreshTaskFormCascadeShowBOList();
            },
            changeSourceOption (e) {
                // console.log(e);
                this.refreshTaskFormCascadeShowBOList();
            },
            changeTargetForm (e) {
                // console.log(e);
                this.refreshTaskFormCascadeShowBOList();
            },
            addLinkData () {
                let item = {
                    id: this.generateUUID(),
                    sourceTaskFormIdStr: '',
                    sourceTaskFormId: '',
                    sourceFieldId: '',
                    sourceFileldOptionKey: '',
                    formId: '',
                    sourceFieldList: [],
                    sourceOptionList: []
                };
                this.linkData.push(item); // list尾部新增
                this.refreshTaskFormCascadeShowBOList();
                // this.nodeInfo.taskFormCascadeShowBOList.push(item);
                // this.nodeInfo.taskFormCascadeShowBOList = cloneDeep(this.nodeInfo.taskFormCascadeShowBOList);
            },
            deleteLinkData (e) {
                for (let i = 0; i < this.nodeInfo.taskFormCascadeShowBOList.length; i++) {
                    let cur = this.nodeInfo.taskFormCascadeShowBOList[i];
                    if (cur.id === e.id) {
                        this.linkData.splice(i, 1);
                        // this.nodeInfo.taskFormCascadeShowBOList.splice(i, 1);
                    }
                }
                this.refreshTaskFormCascadeShowBOList();
            },
            generateUUID () {
                var d = new Date().getTime();
                if (window.performance && typeof window.performance.now === 'function') {
                    d += window.performance.now(); // use high-precision timer if available
                }
                var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                });
                return uuid.replace(RegExp('-', 'g'), '');
            },
            refreshTaskFormCascadeShowBOList () {
                this.nodeInfo.taskFormCascadeShowBOList = cloneDeep(this.linkData);
                // console.log(this.nodeInfo.taskFormCascadeShowBOList);
            },
            // ==============配置表单关联映射end=======================
            // ==============表单同步任务负责人配置beigin=======================
            async initCurTaskForms () {
                // console.log(this.taskData.processServiceId + '===' + this.taskData.deploymentId);
                let tempFormsObj = this.taskData.dataOperate.forms;
                // console.log(this.taskData);
                this.curTaskFormList = [];
                if (tempFormsObj && Array.isArray(tempFormsObj)) {
                    tempFormsObj.forEach(item => {
                        item.taskName = this.taskData.taskName;
                        this.curTaskFormList.push(item);
                    });
                }
                this.dealTaskFormSynAssignUserList();
                // console.log(this.curTaskFormList);
            },
            async getServiceTasks () {
                this.targetTaskList = await getServiceTasks(this.taskData.processServiceId, this.taskData.deploymentId);
            },
            async dealTaskFormSynAssignUserList () {
                if (this.synAssignUserLink && this.synAssignUserLink.length > 0) {
                    this.synAssignUserLink.forEach(async item => {
                        // 初始化每一项的formFieldIdList，用于反显
                        item.formFieldIdList = [];
                        for (let i = 0; i < this.curTaskFormList.length; i++) {
                            let obj = this.curTaskFormList[i];
                            if (obj.formId === item.formId && obj.fieldsList) {
                                obj.fieldsList.forEach(async field => {
                                    if (field.type === 'link' || field.type === 'user') {
                                        item.formFieldIdList.push(field);
                                    }
                                });
                            }
                        }
                    });
                }
                this.refreshTaskFormSynAssignUserList();
            },
            changeCurTaskForm (e) {
                // console.log(e);
                if (e) {
                    e.formId = e.taskFormIdStr.split('#')[0];
                    e.taskId = e.taskFormIdStr.split('#')[1];
                    for (let i = 0; i < this.curTaskFormList.length; i++) {
                        let obj = this.curTaskFormList[i];
                        if (obj.formId === e.formId) {
                            obj.fieldsList.forEach(field => {
                                if (field.type === 'link' || field.type === 'user') {
                                    e.formFieldIdList.push(field);
                                    if (field.type === 'link') {
                                        e.linkFormId = field.options.config.form.formId;
                                        e.linkModelId = field.options.config.form.modelId;
                                    }
                                    e.linkFormFieldIdList = [];
                                }
                            });
                        }
                    }
                }
                this.refreshTaskFormSynAssignUserList();
            },
            async changeFormFieldId (e) { // 关联字段关联的表单及其表单字段
                // console.log(e);
                if (e) { // 查询关联表单的用户字段
                    e.linkFormFieldId = '';
                    e.linkFormFieldIdList = [];
                    let linkFormId = '';
                    for (let i = 0; i < e.formFieldIdList.length; i++) {
                        if (e.formFieldId === e.formFieldIdList[i].id) {
                            e.formFieldType = e.formFieldIdList[i].type;
                            if (e.formFieldType === 'link') {
                                linkFormId = e.formFieldIdList[i].options.config.form.formId;
                            }
                            break;
                        }
                    }
                    // console.log(linkFormId);
                    if (linkFormId) {
                        let formObj = await getFormConfig(linkFormId);
                        formObj.fieldsList.forEach(field => {
                            if (field.type === 'user') {
                                if (field.options.config.type === 'single') {
                                    e.linkFormFieldIdList.push(field);
                                }
                            }
                        });
                    }
                }
                this.refreshTaskFormSynAssignUserList();
            },
            changeLinkFormFieldId (e) {
                // console.log(e);
                this.refreshTaskFormSynAssignUserList();
            },
            changeTargetTask (e) {
                // console.log(e);
                this.refreshTaskFormSynAssignUserList();
            },
            addSynAssignUserLinkData () {
                let item = {
                    id: this.generateUUID(),
                    taskFormIdStr: '',
                    taskId: '',
                    formId: '',
                    formFieldId: '',
                    linkFormId: '',
                    linkModelId: '',
                    linkFormFieldId: '',
                    targetTaskId: '',
                    formFieldIdList: [],
                    linkFormFieldIdList: [],
                    targetTaskList: [],
                    subProcessTemplateId: '',
                    subProcessList: []
                };
                this.synAssignUserLink.push(item); // list尾部新增
                this.refreshTaskFormSynAssignUserList();
                // this.nodeInfo.synTaskAssigneeList.push(item);
            },
            deleteSynAssignUserLinkData (e) {
                for (let i = 0; i < this.nodeInfo.synTaskAssigneeList.length; i++) {
                    let cur = this.nodeInfo.synTaskAssigneeList[i];
                    if (cur.id === e.id) {
                        this.synAssignUserLink.splice(i, 1);
                        // this.nodeInfo.synTaskAssigneeList.splice(i, 1);
                    }
                }
                this.refreshTaskFormSynAssignUserList();
            },
            refreshTaskFormSynAssignUserList () {
                this.nodeInfo.synTaskAssigneeList = cloneDeep(this.synAssignUserLink);
                // console.log(this.nodeInfo.synTaskAssigneeList);
            },
            // ==============表单同步任务负责人配置end=======================
            // ==============表单同步修改下一会签任务负责人配置beigin=======================
            async initCurTaskForms2 () {
                this.dealTaskFormNextNodeAssigneerList();
            },
            async dealTaskFormNextNodeAssigneerList () {
                if (this.updCountersigTaskList && this.updCountersigTaskList.length > 0) {
                    this.updCountersigTaskList.forEach(async item => {
                        // 初始化每一项的formFieldIdList，用于反显
                        item.formFieldIdList = [];
                        for (let i = 0; i < this.curTaskFormList.length; i++) {
                            let obj = this.curTaskFormList[i];
                            if (obj.formId === item.formId) {
                                obj.fieldsList.forEach(field => {
                                    if (field.type === 'subform') {
                                        item.formFieldIdList.push(field);
                                    }
                                });
                            }
                        }
                        await this.changeFormFieldId2(item, true);
                    });
                }
                this.refreshTaskFormNextNodeAssigneerList();
            },
            changeCurTaskForm2 (e) {
                if (e) {
                    e.formId = e.taskFormIdStr.split('#')[0];
                    e.taskId = e.taskFormIdStr.split('#')[1];
                    for (let i = 0; i < this.curTaskFormList.length; i++) {
                        let obj = this.curTaskFormList[i];
                        if (obj.formId === e.formId) {
                            obj.fieldsList.forEach(field => {
                                if (field.type === 'subform') {
                                    e.formFieldIdList.push(field);
                                    // e.subFormFieldIdList = [];
                                    // field.options.fieldList.forEach(subfield => {
                                    //     if (subfield.type === 'user') {
                                    //         e.subFormFieldIdList.push(subfield);
                                    //     }
                                    // });
                                }
                            });
                        }
                    }
                }
                this.subFormFieldIdTime = new Date().getTime();
                this.refreshTaskFormNextNodeAssigneerList();
            },
            async changeFormFieldId2 (e, init) { // 关联字段关联的表单及其表单字段
                e.subFormFieldIdList = [];
                e.subFormFieldIdListAll = [];
                e.formFieldIdList.forEach(field => {
                    if (field.type === 'subform' && field.id === e.formFieldId) {
                        if (!init) {
                            e.subFormFieldId = '';
                        }
                        field.options.fieldList.forEach(subfield => {
                            if (subfield.type === 'user') {
                                e.subFormFieldIdList.push(subfield);
                            }
                            e.subFormFieldIdListAll.push(subfield);
                        });
                    }
                });
                this.subFormFieldIdTime = new Date().getTime();
                if (init) {
                    await this.setSubProcessList(e);
                }
                this.refreshTaskFormNextNodeAssigneerList();
            },
            changeSubFieldId2 (e) {
                // console.log(e);
                this.refreshTaskFormNextNodeAssigneerList();
            },
            async changeTargetTask2 (e) {
                if (e) {
                // e = this.targetTaskList[this.targetTaskList.findIndex((item) => item.id === e)];
                    let taskObj = this.targetTaskList.find(item => item.id === e);
                    taskObj.targetTaskId = e;
                    await this.setSubProcessList(taskObj);
                }
            },
            async changeSubprocess (obj) {
                this.refreshTaskFormNextNodeAssigneerList();
                // e = this.targetTaskList[this.targetTaskList.findIndex((item) => item.id === e)];
            },
    
            async setSubProcessList (taskObj) {
                let taskData = await getProcessServiceConfig(taskObj.processServiceId, taskObj.deploymentId, taskObj.targetTaskId);
                if (taskData) {
                    let obj = this.updCountersigTaskList.find(item => item.targetTaskId === taskObj.targetTaskId);
                    obj.subProcessList = [];
                    if (taskData.nodeInfo.subProcesslTemplateList) {
                        obj.subProcessList = taskData.nodeInfo.subProcesslTemplateList;
                    }
                }
                this.subProcessListTime = new Date().getTime();
                this.refreshTaskFormNextNodeAssigneerList();
            },
            async handleViewSubProcess (obj) {
                if (obj.subProcessTemplateId) {
                    let subProcess = obj.subProcessList.find(item => item.id === obj.subProcessTemplateId);
                    this.handleViewProcessTemplate(subProcess);
                } else {
                    this.$message({message: '请选择子流程模板', type: 'warning'});
                }
            },
            addNextNodeAssigneerLinkData () {
                let item = {
                    id: this.generateUUID(),
                    taskFormIdStr: '',
                    taskId: '',
                    formId: '',
                    formFieldId: '',
                    subFormFieldId: '',
                    targetTaskId: '',
                    formFieldIdList: [],
                    subFormFieldIdList: [],
                    subFormFieldIdListAll: [],
                    targetTaskList: [],
                    subProcessTemplateId: '',
                    subProcessNameFieldId: '',
                    subProcessList: []
                };
                this.updCountersigTaskList.push(item); // list尾部新增
                this.refreshTaskFormNextNodeAssigneerList();
            },
            deleteNextNodeAssigneerLinkData (e) {
                for (let i = 0; i < this.nodeInfo.updCountersigTaskList.length; i++) {
                    let cur = this.nodeInfo.updCountersigTaskList[i];
                    if (cur.id === e.id) {
                        this.updCountersigTaskList.splice(i, 1);
                    }
                }
                this.refreshTaskFormNextNodeAssigneerList();
            },
            refreshTaskFormNextNodeAssigneerList () {
                this.nodeInfo.updCountersigTaskList = cloneDeep(this.updCountersigTaskList);
            },
            // ==============表单同步任务负责人配置end=======================
            // ==============表单控制其他任务节点按钮显示配置beigin=======================
            async initCurTaskForms3 () {
                this.dealTaskFormOtherNodeBtnList();
            },
            async dealTaskFormOtherNodeBtnList () {
                if (this.synTaskBtnList && this.synTaskBtnList.length > 0) {
                    this.synTaskBtnList.forEach(async item => {
                        // 初始化每一项的formFieldIdList，用于反显
                        item.formFieldIdList = [];
                        for (let i = 0; i < this.curTaskFormList.length; i++) {
                            let obj = this.curTaskFormList[i];
                            if (obj.formId === item.formId) {
                                if (obj.fieldsList) {
                                    obj.fieldsList.forEach(field => {
                                        if (field.type === 'category' || field.type === 'select') {
                                            if (field.options.config.type === 'single') {
                                                item.formFieldIdList.push(field);
                                            }
                                        } else if (field.type === 'number') {
                                            item.formFieldIdList.push(field);
                                        }
                                    });
                                }
                            }
                        }
                        // 初始化每一项的formFieldKeyList，用于反显
                        item.formFieldKeyList = [];
                        for (let i = 0; i < item.formFieldIdList.length; i++) {
                            let obj = item.formFieldIdList[i];
                            if (obj.id === item.formFieldId) {
                                item.formFieldKeyList = cloneDeep(obj.options.config.options);
                            }
                        }
                    });
                }
                this.refreshTaskFormOtherNodeBtnList();
            },
            changeCurTaskForm3 (e) {
                // console.log(e);
                if (e) {
                    e.formId = e.taskFormIdStr.split('#')[0];
                    e.taskId = e.taskFormIdStr.split('#')[1];
                    for (let i = 0; i < this.curTaskFormList.length; i++) {
                        let obj = this.curTaskFormList[i];
                        if (obj.formId === e.formId) {
                            obj.fieldsList.forEach(field => {
                                if (field.type === 'category' || field.type === 'select') {
                                    if (field.options.config.type === 'single') {
                                        e.formFieldIdList.push(field);
                                    }
                                } else if (field.type === 'number') {
                                    e.formFieldIdList.push(field);
                                }
                            });
                        }
                    }
                }
                this.refreshTaskFormOtherNodeBtnList();
            },
            changeFormFieldId3 (e) {
                // console.log(e);
                if (e) {
                    for (let i = 0; i < e.formFieldIdList.length; i++) {
                        let obj = e.formFieldIdList[i];
                        if (obj.id === e.formFieldId) {
                            e.formFieldType = obj.type;
                            e.formFieldKeyList = cloneDeep(obj.options.config.options);
                            break;
                        }
                    }
                }
                this.refreshTaskFormOtherNodeBtnList();
            },
            changeformFieldKey (e) {
                // console.log(e);
                this.refreshTaskFormOtherNodeBtnList();
            },
            changeTargetTask3 (e) {
                // console.log(e);
                if (e) {
                    if (e.targetTaskId) {
                        for (let i = 0; i < this.targetTaskList.length; i++) {
                            let obj = this.targetTaskList[i];
                            if (obj.id === e.targetTaskId) {
                                e.targetTaskBtnList = cloneDeep(obj.operationBtns);
                            }
                        }
                    }
                }
                this.refreshTaskFormOtherNodeBtnList();
            },
            changeTargetTaskBtn (e) {
                this.refreshTaskFormOtherNodeBtnList();
            },
            addOtherNodeBtnLinkData () {
                let item = {
                    id: this.generateUUID(),
                    taskFormIdStr: '',
                    taskId: '',
                    formId: '',
                    formFieldId: '',
                    formFieldType: 'select', // 支持下拉、选择、数字number,默认是下拉
                    formFieldKey: '',
                    formFieldValue: '', // 用于比较的目标值
                    optCondition: 0, // 0：等于 1：大于 2：大于等于 3：小于 4：小于等于，默认0
                    targetTaskId: '',
                    targetTaskBtnId: '',
                    formFieldKeyList: [],
                    formFieldIdList: [],
                    targetTaskList: [],
                    targetTaskBtnList: [],
                    subProcessTemplateId: '',
                    subProcessList: []
                };
                this.synTaskBtnList.push(item); // list尾部新增
                this.refreshTaskFormOtherNodeBtnList();
            },
            deleteOtherNodeBtnLinkData (e) {
                for (let i = 0; i < this.nodeInfo.synTaskBtnList.length; i++) {
                    let cur = this.nodeInfo.synTaskBtnList[i];
                    if (cur.id === e.id) {
                        this.synTaskBtnList.splice(i, 1);
                    }
                }
                this.refreshTaskFormOtherNodeBtnList();
            },
            refreshTaskFormOtherNodeBtnList () {
                this.nodeInfo.synTaskBtnList = cloneDeep(this.synTaskBtnList);
            },
            // ==============表单控制其他任务节点按钮显示配置end=======================

            // ==============表单审批模板关联关系配置beigin=======================
            async initCurTaskForms4 () {
                this.dealFormApprovalList();
            },
            async dealFormApprovalList () {
                if (this.formApprovalList && this.formApprovalList.length > 0) {
                    this.formApprovalList.forEach(async item => {
                        // 初始化每一项的formFieldIdList，用于反显
                        item.formFieldIdList = [];
                        for (let i = 0; i < this.curTaskFormList.length; i++) {
                            let obj = this.curTaskFormList[i];
                            if (obj.formId === item.formId) {
                                if (obj.fieldsList) {
                                    obj.fieldsList.forEach(field => {
                                        if (field.type === 'category' || field.type === 'select') {
                                            if (field.options.config.type === 'single') {
                                                item.formFieldIdList.push(field);
                                            }
                                        }
                                        if (field.type === 'department') { // 20230905增加按部门进行级联设置审批流模板的逻辑
                                            if (field.options.config.type === 'single') {
                                                item.formFieldIdList.push(field);
                                            }
                                        }
                                    });
                                }
                            }
                        }
                        // 初始化每一项的formFieldKeyList，用于反显
                        item.formFieldKeyList = [];
                        for (let i = 0; i < item.formFieldIdList.length; i++) {
                            let obj = item.formFieldIdList[i];
                            if (obj.id === item.formFieldId) {
                                if (item.formFieldType === 'department') {
                                    if (item.formFieldValue && item.formFieldValue.indexOf(';') !== -1) {
                                        let idLabelArr = item.formFieldValue.split(';');
                                        item.departmentBO = {'ids': idLabelArr[0], 'labels': idLabelArr[1]};
                                        item.formFieldKeyList = [];
                                    }
                                } else {
                                    item.formFieldKeyList = cloneDeep(obj.options.config.options);
                                }
                            }
                        }
                    });
                }
                this.refreshFormApprovalLinkList();
            },
            changeCurTaskForm4 (e) {
                // console.log(e);
                if (e) {
                    e.formId = e.taskFormIdStr.split('#')[0];
                    e.taskId = e.taskFormIdStr.split('#')[1];
                    for (let i = 0; i < this.curTaskFormList.length; i++) {
                        let obj = this.curTaskFormList[i];
                        if (obj.formId === e.formId) {
                            obj.fieldsList.forEach(field => {
                                if (field.type === 'category' || field.type === 'select') {
                                    if (field.options.config.type === 'single') {
                                        e.formFieldIdList.push(field);
                                    }
                                }
                                if (field.type === 'department') { // 20230905增加按部门进行级联设置审批流模板的逻辑
                                    if (field.options.config.type === 'single') {
                                        e.formFieldIdList.push(field);
                                    }
                                }
                            });
                        }
                    }
                }
                this.refreshFormApprovalLinkList();
            },
            changeFormFieldId4 (e) {
                // console.log(e);
                if (e) {
                    for (let i = 0; i < e.formFieldIdList.length; i++) {
                        let obj = e.formFieldIdList[i];
                        if (obj.id === e.formFieldId) {
                            e.formFieldType = obj.type;
                            if (obj.type === 'department') { // TODO: 20230905 这里加入部门 配置逻辑
                                e.formFieldKeyList = [];
                            } else {
                                e.formFieldKeyList = cloneDeep(obj.options.config.options);
                            }
                            break;
                        }
                    }
                }
                this.refreshFormApprovalLinkList();
            },
            changeformFieldKey2 (e) {
                // console.log(e);
                this.refreshFormApprovalLinkList();
            },
            changeTargetApproval (e) {
                // console.log(e);
                this.refreshFormApprovalLinkList();
            },
            addFormApprovalLinkData () {
                let item = {
                    id: this.generateUUID(),
                    taskFormIdStr: '',
                    taskId: '',
                    formId: '',
                    formFieldId: '',
                    formFieldType: 'select', // 支持下拉、选择、数字number,默认是下拉
                    formFieldKey: '',
                    formFieldValue: '', // 用于比较的目标值
                    optCondition: 0, // 0：等于 1：大于 2：大于等于 3：小于 4：小于等于，默认0
                    targetTaskId: '',
                    targetTaskBtnId: '',
                    formFieldKeyList: [],
                    formFieldIdList: [],
                    approvalTemplateId: '',
                    subProcessTemplateId: '',
                    subProcessList: []
                };
                this.formApprovalList.push(item); // list尾部新增
                this.refreshFormApprovalLinkList();
            },
            deleteFormApprovalLinkData (e) {
                for (let i = 0; i < this.nodeInfo.formApprovalList.length; i++) {
                    let cur = this.nodeInfo.formApprovalList[i];
                    if (cur.id === e.id) {
                        this.formApprovalList.splice(i, 1);
                    }
                }
                this.refreshFormApprovalLinkList();
            },
            refreshFormApprovalLinkList () {
                this.nodeInfo.formApprovalList = cloneDeep(this.formApprovalList);
            },
            // ==============表单审批模板关联关系配置end=======================
            // ==============任务摘要配置beigin=======================
            async initCurTaskForms5 () {
                let tempFormsObj = null;
                if (this.processInstance) {
                    tempFormsObj = await getAllProcessTaskForms({// 查询流程实例对应的所有表单
                        processInstanceId: this.processInstance.id,
                        processServiceId: this.taskData.processServiceId,
                        deploymentId: this.taskData.deploymentId,
                        onlyThis: true
                    });
                } else {
                    tempFormsObj = await getProcessServiceTaskForms({// 查询流程模板对应的所有表单
                        processServiceId: this.taskData.processServiceId,
                        deploymentId: this.taskData.deploymentId,
                        time: new Date().getTime()
                    });
                }
                this.targetFormList = [];
                if (tempFormsObj && Array.isArray(tempFormsObj)) {
                    // let taskModeType = this.taskData.executor.modeType;
                    tempFormsObj.forEach(item => {
                        let objModelFormStructure = item.structure;
                        if (objModelFormStructure) {
                            objModelFormStructure.forEach(form => {
                                this.allTaskFormList.push(form);
                            });
                        }
                    });
                }
                this.dealTaskRemarkList();
            },
            async dealTaskRemarkList () {
                if (this.taskRemarkList && this.taskRemarkList.length > 0) {
                    this.taskRemarkList.forEach(async item => {
                        // 初始化每一项的sourceFieldList，用于反显
                        item.sourceFieldList = [];
                        // console.log(this.allTaskFormList);
                        for (let i = 0; i < this.allTaskFormList.length; i++) {
                            let obj = this.allTaskFormList[i];
                            if (obj.id === item.sourceFormId) {
                                item.sourceFieldList = cloneDeep(obj.fieldsList);
                            }
                        }
                    });
                }
                this.refreshTaskRemarkList();
            },
            changeCurTaskForm5 (e) {
                // console.log(e);
                if (e) {
                    e.sourceFormId = e.sourceTaskFormIdStr.split('#')[0];
                    e.sourceTaskId = e.sourceTaskFormIdStr.split('#')[1];
                    for (let i = 0; i < this.allTaskFormList.length; i++) {
                        let obj = this.allTaskFormList[i];
                        if (obj.id === e.sourceFormId) {
                            e.sourceTaskFormName = obj.formName;
                            e.sourceFieldList = cloneDeep(obj.fieldsList);
                        }
                    }
                }
                this.refreshTaskRemarkList();
            },
            changeFormFieldId5 (e) {
                // console.log(e);
                if (e) {
                    for (let i = 0; i < e.sourceFieldList.length; i++) {
                        let obj = e.sourceFieldList[i];
                        if (obj.id === e.sourceFormFieldId) {
                            e.sourceFormFieldType = obj.type;
                            break;
                        }
                    }
                }
                this.refreshTaskRemarkList();
            },
            addTaskRemarkLinkData () {
                let item = {
                    id: this.generateUUID(),
                    sourceTaskFormIdStr: '',
                    taskId: '',
                    sourceTaskId: '',
                    sourceFormId: '',
                    sourceFormName: '',
                    sourceFormFieldId: '',
                    sourceFormFieldType: '',
                    sourceFieldList: []
                };
                this.taskRemarkList.push(item); // list尾部新增
                this.refreshTaskRemarkList();
            },
            deleteTaskRemarkLinkData (e) {
                for (let i = 0; i < this.nodeInfo.taskRemarkList.length; i++) {
                    let cur = this.nodeInfo.taskRemarkList[i];
                    if (cur.id === e.id) {
                        this.taskRemarkList.splice(i, 1);
                    }
                }
                this.refreshTaskRemarkList();
            },
            refreshTaskRemarkList () {
                this.nodeInfo.taskRemarkList = cloneDeep(this.taskRemarkList);
            },
            // ==============任务摘要配置end=======================
            handleDeptTreeNode (data, node, tree) {
                for (let i = 0; i < this.formApprovalList.length; i++) {
                    let cur = this.formApprovalList[i];
                    if (cur.id === data.currentPK) {
                        cur.formFieldValue = data.id + ';' + data.label;
                    }
                }
                this.refreshFormApprovalLinkList();
            }
        }
    };
</script>

<style lang="less">
    .node-info {
     .subProcess{
            width:1000px;
            height:500px;
            margin-top: -5%;
        }
        .el-step__main .el-breadcrumb{
            display: inline-block;
            .el-breadcrumb__item{
                .el-breadcrumb__inner{
                    color:#409eff;
                    a:hover{
                        color:#409eff;
                    }
                }
                .el-breadcrumb__separator{
                    color:#409eff;
                }
            }
        
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/process/ProcessEditor/components/NodeInfo.vue